import { Badge } from "@/components/ui/badge"
import { Panel } from "@/components/ui/panel"

import type { AllowlistState, Transport } from "../types"

/**
 * The routing gate itself: who receives live mail, and how to change that.
 * An empty-but-applying list is configured behaviour, never a fault — the
 * server-written `meaning` prose carries that distinction verbatim.
 */
export function Allowlist({
  allowlist,
  transport,
}: {
  allowlist: AllowlistState
  transport: Transport
}) {
  return (
    <Panel
      id="allowlist"
      title="Allowlist"
      description={
        allowlist.applies
          ? `${allowlist.source} · ${
              allowlist.empty
                ? "empty"
                : `${allowlist.count} address(es) receive live mail`
            }`
          : `Not used by ${transport.provider}`
      }
    >
      <p className="text-tertiary text-sm">{allowlist.meaning}</p>
      {allowlist.entries.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {allowlist.entries.map((entry) => (
            <Badge key={entry} type="modern" color="gray" size="sm">
              {entry}
            </Badge>
          ))}
        </div>
      )}
      {allowlist.applies && (
        <p className="text-tertiary text-sm">
          To change it, set {allowlist.source} in the Render dashboard as
          comma-separated addresses. The service reads it once at boot, so a
          change needs a restart. It lives only in the Render dashboard, never
          in the repo.
        </p>
      )}
    </Panel>
  )
}
